import { Col, TitleText, UtilityText } from '@policygenius/mortar';
import classnames from 'classnames';
import React from 'react';

import styles from './dynamic-form-wrapper.module.scss';
import { Props } from './types';

const DynamicFormWrapper: React.FC<Props> = ({ children, interviewDisplayName, heading }) => (
  <Col push={{ medium: 2, large: 3 }} span={{ small: 4, medium: 8, large: 6 }}>
    {(!!interviewDisplayName || !!heading) && (
      <div className={classnames(heading && styles.headerWrapper)}>
        {interviewDisplayName && (
          <UtilityText className={styles.section} size="small" color="secondary" weight="bold">
            {interviewDisplayName}
          </UtilityText>
        )}
        {heading && <TitleText className={styles.title}>{heading}</TitleText>}
      </div>
    )}
    {children}
  </Col>
);

export default DynamicFormWrapper;
